import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Chip, Paper, Snackbar, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import AdminService from '../../services/AdminService';

const STATUS_COLORS = {
  sent: 'success', scheduled: 'info', draft: 'default', failed: 'error', running: 'warning',
};

export default function BroadcastsAdminView() {
  const [broadcasts, setBroadcasts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  useEffect(() => {
    AdminService.getAllBroadcasts()
      .then((data) => setBroadcasts(data || []))
      .catch(() => setSnackbar({ open: true, message: 'Failed to load broadcasts', severity: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} mb={2}>Broadcasts</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Service ID</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Recipients</TableCell>
              <TableCell>Sent</TableCell>
              <TableCell>Read</TableCell>
              <TableCell>Replied</TableCell>
              <TableCell>Failed</TableCell>
              <TableCell>Schedule</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={10} align="center">Loading…</TableCell></TableRow>
            ) : broadcasts.length === 0 ? (
              <TableRow><TableCell colSpan={10} align="center">No broadcasts found</TableCell></TableRow>
            ) : broadcasts.map((b) => (
              <TableRow key={b.id} hover>
                <TableCell>{b.name}</TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{b.service_id}</TableCell>
                <TableCell>
                  <Chip label={b.status} color={STATUS_COLORS[b.status] || 'default'} size="small" />
                </TableCell>
                <TableCell>{b.recipients ?? '—'}</TableCell>
                <TableCell>{b.successfull ?? '—'}</TableCell>
                <TableCell>{b.read ?? '—'}</TableCell>
                <TableCell>{b.replied ?? '—'}</TableCell>
                <TableCell>{b.failed ?? '—'}</TableCell>
                <TableCell>{b.schedule ? new Date(b.schedule).toLocaleString() : '—'}</TableCell>
                <TableCell>{b.created_at ? new Date(b.created_at).toLocaleDateString() : '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
